// extracted by mini-css-extract-plugin
module.exports = {"Time":"PickUpToday_Time__OZvY6","pickGreen":"PickUpToday_pickGreen__xLYHt","pickOrange":"PickUpToday_pickOrange__VrP_k","pickRed":"PickUpToday_pickRed__Qll_4"};